module.exports = __webpack_public_path__ + "img/corpWechatConfig.a5ca4fa0.png";